import angular from 'angular';

angular.module('myConsultApp').directive('pointHistoryRow', () => {
  return {
    templateUrl: 'templates/v2/point-history-row.html',
    restrict: 'E',
  };
});
